import * as React from "react";
import * as ReactDOM from "react-dom";
import AutoCompleteComponentReact from "./AutoCompleteComponentReact";
import { ReactComponent } from "lexisnexis-form";
import settingsForm from "./AutoCompleteComponent.settingsForm";
import { IAutoCompleteComponent } from "./business-objects/IAutoCompleteComponent";
import {ComponentUtils} from "./business-objects/ComponentUtils";


export default class AutoCompleteComponent extends ReactComponent {
  private component: IAutoCompleteComponent;
  private updateValue: any;
  private dataValue: any;
  private root: any;
  private on: Function;
  private parentValue: string;
  private error: any;
  private reactInstance: AutoCompleteComponentReact;

  private parentReadAttempt: number;

  static schema(...extend) {
    const schema = ReactComponent.schema(
      {
        type: "AutoCompleteComponent",
        key: "AutoCompleteComponent",
        label: "Auto Complete Textbox",
        placeholder: ""
      },
      ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: "Auto Complete Textbox",
      group: "advanced",
      icon: "comments",
      weight: -10,
      schema: AutoCompleteComponent.schema()
    };
  }

  get emptyValue() {
    return "";
  }

  static editForm = settingsForm;

  focus() {
    if (this.reactInstance) {
      this.reactInstance.focus();
    }
  }

  getTranscriptionLookupError(): string | null {
    return this.reactInstance && this.reactInstance.hasUnmatchedTranscribedValue()
      ? `Select a matching lookup value for ${this.component.label || this.component.key}. The transcribed value has been retained.`
      : null;
  }

  setParentValue(updateComponentState: boolean) {
    if (this.component.parentApiName) {
      this.parentValue = "";
      let parentValueComponent = ComponentUtils.getComponent(this, this.component.parentApiName);

      if (!parentValueComponent) {
        //parent component doesn't exist or hasn't been created yet
        //check every x ms to see if parent has been created.
        //only try x times to read parent, after that give up
        this.parentReadAttempt = this.parentReadAttempt + 1;

        if (this.parentReadAttempt < (this.component.parentComponentInitMaxAttempts || 10)) {
          setTimeout(() => {
            this.setParentValue(true);
          }, this.component.parentComponentInitInterval || 500);
        }
      } else {
        this.parentValue = parentValueComponent.dataValue || parentValueComponent.getValue();

        if (updateComponentState && this.reactInstance && this.reactInstance.setState) {
          //setting state of react component directly instead of calling redraw
          this.reactInstance.setState({ parentValue: this.parentValue });
        }
      }
    }
  }


  init() {
    this.parentReadAttempt = 0;
    this.on("validationFinished", event => {
      if (this.reactInstance && this.reactInstance.setState) {
        this.reactInstance.setState({ isValid: !this.error });
      }
    });
    //don't set up listener if no parent set
    if (this.component.parentApiName) {
      this.setParentValue(false);

      this.on("componentChange", event => {
        if (
            this.component.parentApiName &&
            event.instance.component &&
            event.instance.component.key &&
            this.component.parentApiName.endsWith(event.instance.component.key)
        ) {
          let lastFocusedItem;
          if (document && document.activeElement && document.activeElement.id) {
            lastFocusedItem = document.activeElement.id;
          }
          this.setParentValue(true);
          if (lastFocusedItem) {
            document.getElementById(lastFocusedItem).focus();
          }
        }
      });
    }
  }



  attachReact(element) {
    return ReactDOM.render(
      <AutoCompleteComponentReact
          component={this.component}
          value={this.dataValue || ""}
          description={this.dataValue.description || ""}
          onChange={this.updateValue}
          formData={this.root}
          parentValue={this.parentValue}
          isValid={!this.error}
      />,
      element
    );
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
